import { up, down } from 'slide-element';
import announcer from './aria-announcer';

const $accordionWrappers = document.querySelectorAll('.block-accordion, .block-filters-accordion');
const $btnToggleAccordions = document.querySelector('.btn-toggle-accordions');

if ($btnToggleAccordions && $accordionWrappers.length) {
    $btnToggleAccordions.style.display = 'flex';
}

$accordionWrappers.forEach(($wrapper) => {
    const $button = $wrapper.querySelector('.accordion-button');
    const $panel = $wrapper.querySelector('.accordion-panel');

    $button.setAttribute('aria-expanded', 'true');
    $panel.setAttribute('aria-hidden', 'false');
    down($panel);

    $button.addEventListener('click', () => {
        const isExpanded = $button.getAttribute('aria-expanded') === 'true';

        $button.setAttribute('aria-expanded', !isExpanded);
        $panel.setAttribute('aria-hidden', isExpanded);

        if (!isExpanded) {
            down($panel);
            announcer.announce(`Le tiroir ${$button.textContent} est ouvert`);
        } else {
            up($panel);
            announcer.announce(`Le tiroir ${$button.textContent} est fermé`);
        }
    });
});

if ($btnToggleAccordions) {
    const $labelOpen = $btnToggleAccordions.querySelector('.btn-label-open');
    const $labelClose = $btnToggleAccordions.querySelector('.btn-label-close');

    const updateLabels = (isOpen) => {
        if (isOpen) {
            $labelClose.style.display = '';
            $labelOpen.style.display = 'none';
        } else {
            $labelClose.style.display = 'none';
            $labelOpen.style.display = '';
        }
    };

    $btnToggleAccordions.classList.add('is-open');
    updateLabels(true);

    $btnToggleAccordions.addEventListener('click', () => {
        const allExpanded = Array.from($accordionWrappers).every(($wrapper) => {
            const $button = $wrapper.querySelector('.accordion-button');
            return $button.getAttribute('aria-expanded') === 'true';
        });

        $accordionWrappers.forEach(($wrapper) => {
            const $button = $wrapper.querySelector('.accordion-button');
            const $panel = $wrapper.querySelector('.accordion-panel');

            if (allExpanded) {
                $button.setAttribute('aria-expanded', 'false');
                $panel.setAttribute('aria-hidden', 'true');
                up($panel);
            } else {
                $button.setAttribute('aria-expanded', 'true');
                $panel.setAttribute('aria-hidden', 'false');
                down($panel);
            }
        });

        if (allExpanded) {
            announcer.announce('Toutes les listes sont fermées');
            $btnToggleAccordions.classList.remove('is-open');
            updateLabels(false);
        } else {
            announcer.announce('Toutes les listes sont ouvertes');
            $btnToggleAccordions.classList.add('is-open');
            updateLabels(true);
        }
    });
}
